<template lang="pug">
    section
        v-container(fluid).pa-0
            v-expansion-panels(light tile)
                v-expansion-panel
                    v-expansion-panel-header Фильтры и поиск
                        div.ml-5
                            v-btn(rounded small @click.stop="filters_clear") Очистить
                    v-expansion-panel-content
                        v-row
                            v-col(cols="12", md="3").py-0
                                v-menu(
                                    v-model='datepicker_menu_from'
                                    :close-on-content-click='false'
                                    :nudge-right='40'
                                    transition='scale-transition'
                                    offset-y
                                    min-width='290px'
                                    ref="datepicker_menu_from"
                                )
                                    template(v-slot:activator='{ on, attrs }')
                                        v-text-field(
                                            v-model='dateFromFormatted'
                                            label='Начало периода'
                                            prepend-icon='mdi-calendar'
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        )
                                    v-date-picker(v-model='table_filters.dates.from'  @input="datepicker_menu_from = false")
                            v-col(cols="12", md="3").py-0
                                v-menu(
                                    v-model='datepicker_menu_to'
                                    :close-on-content-click='false'
                                    :nudge-right='40'
                                    transition='scale-transition'
                                    offset-y
                                    min-width='290px'
                                    ref="datepicker_menu_to"
                                )
                                    template(v-slot:activator='{ on, attrs }')
                                        v-text-field(
                                            v-model='dateToFormatted'
                                            label='Конец периода'
                                            prepend-icon='mdi-calendar'
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        )
                                    v-date-picker(
                                        v-model='table_filters.dates.to'
                                        @input="datepicker_menu_to = false"
                                        locale="ru-RU"
                                    )
                            v-spacer
                            v-col.py-0
                                v-text-field(
                                    v-model="table_filters.search"
                                    append-icon="mdi-magnify"
                                    label="Поиск по сделкам"
                                    single-line
                                    hide-details
                                )
        v-data-table.elevation-0.mt-1(
            :header-props="headerProps"
            :headers='tableHeaders'
            :search="table_filters.search"
            item-key="id"
            fixed-header
            disable-pagination
            hide-default-footer
            :items='deals'
        )
            template(v-slot:item.date_buy="{ item }") {{ item.date_buy | formatDateToLocale }}
            template(v-slot:item.symbol.full_name="{ item }")
                b {{ item.symbol.full_name }}
            template(v-slot:item.action="{ item }") Покупка
            template(v-slot:item.buy_cost="{ item }") {{ item.buy_cost | toUSD }}
            template(v-slot:item.commission.buy="{ item }") {{ item.commission.buy | toUSD }}
            template(v-slot:item.get_deal_cost_info.deal_cost_buy="{ item }") {{ item.get_deal_cost_info.deal_cost_buy | toUSD }}
</template>

<script>
    export default {
        name: "PortfolioHistoryOpen",
        props: {
            deals: Array
        },
        computed: {
            dateFromFormatted () {
                return this.table_filters.dates.from ? this.$options.filters.formatDateToLocale(this.table_filters.dates.from) : null
            },
            dateToFormatted () {
                return this.table_filters.dates.to ? this.$options.filters.formatDateToLocale(this.table_filters.dates.to) : null
            }
        },
        data () {
            return {
                table_filters: {
                    dates:{
                        from: null,
                        to: null,
                    },
                    search:''
                },
                datepicker_menu_from: null,
                datepicker_menu_to: null,
                headerProps: {
                    sortByText: "Упорядочить по"
                },
                tableHeaders: [
                    {
                        text: 'Дата',
                        align: 'start',
                        sortable: true,
                        value: 'date_buy',
                        fixed: true,
                        width: '140px',
                        filter: value => {
                            if (!((this.table_filters.dates.from) && (this.table_filters.dates.to))) return true
                            let date_from = new Date(Date.parse(this.table_filters.dates.from))
                            let date_to = new Date(Date.parse(this.table_filters.dates.to))
                            let date_item = new Date(Date.parse(value))
                            return (date_from < date_item) && (date_item < date_to)
                        }
                    },
                    {
                        text: 'Действие',
                        align: 'start',
                        sortable: false,
                        value:'action'
                    },
                    {
                        text: 'Название',
                        sortable: true,
                        value: 'symbol.full_name',
                        width: '300px'
                    },
                    { text: 'Тикер', value: 'symbol.short' },
                    { text: 'Цена акции', value: 'buy_cost' },
                    { text: 'Количество', value: 'count' },
                    { text: 'Общая комиссия', value: 'commission.buy'},
                    { text: 'Сумма с комиссией клиента', value: 'get_deal_cost_info.deal_cost_buy'},
                ],
            }
        },
        methods: {
            filters_clear () {
                for (let item in this.table_filters.dates) {
                    this.table_filters.dates[item] = null
                }
                this.table_filters.search = ''
            }
        }
    }
</script>

<style scoped>

</style>
